import React from 'react';
import Token from '../../components/token/TokenContainer';

export default function TokenPage() {
  React.useEffect(() => {
    document.title = "Shems Almadina - Parc informatique"
    return () => {
      document.title = "Shems Almadina"
    };
  }, []);
  return (
    <Token />
  );
}
